module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAoCAYAAABpYH0BAAAABHNCSVQICAgIfAhkiAAAAAFzUkdCAK7OHOkAAAAEZ0FNQQAAsY8L/GEFAAAACXBIWXMAABJ0AAASdAHeZh94AAABEklEQVRoQ+3asQkCMRjF8egc9hY29u7gEi7gBBZO4AIu4S5uYCcITqDkSOAIBs68l1xI3g8ksf375U4PF+vt7mMq9n493a5OS7dKIgUEKSBIAUEKCFJAkAKCFBCkgCAFBCkgSAFBfz9MWB2vw/q4HIY1N8bDhM355nbG3E97t+MoNoE2vH+VNI5nhe9R1IBzRYqJxWJG7OYayD66XrMBf133xhFZU5g1YC3H2cdiHl2v2QkMj2wYj3WkoYC13TTm0PRNJDZlrOmzmg5ohbGY8azmA+bWRUA/dezps7r4LZxTckCGKR9CasAp3/kYE9lswFL03xiQ7sIgBQQpIEgBQQoIUkCQAoIUEKSAIAUEKSDEmC81ZVdyNYHd5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/addressView.png
// module id = 1335
// module chunks = 0